module.exports = __webpack_public_path__ + "img/p05.f0ce3c07.jpg";